import Utility from '../../../../../../../util/utilityfunctions';

export const getFlattenContacts = (list) => {
	const flatted = [];
	list.forEach(({contacts}) => flatted.push(...contacts));
	return flatted;
};

const getFlattenEngagements = (list) => {
	return list.map(({engagements}) => engagements).flat();
};

const getFlattenServiceLines = (list) => {
	return list.map(({serviceLine, serviceLineId}) => ({serviceLine, serviceLineId}));
};

const getFlattenRoles = (list) => {
	return list.map(({roleName, roleId}) => ({roleName, roleId}));
};

export const getUniqueContacts = (list) =>
	list.reduce((acc, curr) => (acc.some(({userId}) => userId === curr.userId) ? acc : [...acc, {...curr}]), []);



const getUniqueEngagements = (list) =>
	list.reduce(
		(acc, curr) => (acc.some(({engagementId}) => engagementId === curr.engagementId) ? acc : [...acc, {...curr}]),
		[]
	);

const getUniqueServiceLines = (list) =>
	list.reduce(
		(acc, curr) => (acc.some(({serviceLineId}) => serviceLineId === curr.serviceLineId) ? acc : [...acc, {...curr}]),
		[]
	);
const getUniqueRoles = (list) =>
	list.reduce((acc, curr) => (acc.some(({roleId}) => roleId === curr.roleId) ? acc : [...acc, {...curr}]), []);


const getMappedEngagements = (list) =>
	list.map(({description, engagementId}) => ({
		label: description.toString(),
		value: engagementId,
		id: engagementId,
		selected: false,
		disabled: false
	}));

const getMappedServiceLines = (list) =>
	list.map(({serviceLine, serviceLineId}) => ({
		label: serviceLine.toString(),
		value: serviceLineId,
		id: serviceLineId,
		selected: false,
		disabled: false
	}));

const getMappedRoles = (list) =>
	list.map(({roleName, roleId}) => ({
		label: roleName.toString(),
		value: roleId,
		id: roleId,
		selected: false,
		disabled: false
	}));

export default (list) => {
	const uniqueContacts = getUniqueContacts(getFlattenContacts(list));

	return {
		//contactList: getMappedContacts(uniqueContacts),
		serviceLineList: getMappedServiceLines(
			Utility.sortListData(getUniqueServiceLines(getFlattenServiceLines(uniqueContacts)), 'serviceLine')
		),
		roleList: getMappedRoles(Utility.sortListData(getUniqueRoles(getFlattenRoles(uniqueContacts)), 'roleName'))
	};
};